"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Constants_1 = require("./utils/Constants");
var Hashing_1 = require("./utils/Hashing");
var StatsigLocalStorage_1 = __importDefault(require("./utils/StatsigLocalStorage"));
var SDKVersion_1 = require("./SDKVersion");
var Identity = /** @class */ (function () {
    function Identity(sdkKey, user, overrideStableID) {
        var _a;
        this._sdkType = 'js-lite';
        this._sdkKey = sdkKey;
        this._user = user;
        this._sdkVersion = SDKVersion_1.version;
        var stableID = overrideStableID;
        stableID =
            (_a = stableID !== null && stableID !== void 0 ? stableID : StatsigLocalStorage_1.default.getItem(Constants_1.STATSIG_STABLE_ID_KEY)) !== null && _a !== void 0 ? _a : this._getUUID();
        this._statsigMetadata = {
            stableID: stableID,
            sdkType: this._sdkType,
            sdkVersion: this._sdkVersion,
        };
    }
    Identity.prototype.saveStableID = function () {
        if (this._statsigMetadata.stableID != null) {
            StatsigLocalStorage_1.default.setItem(Constants_1.STATSIG_STABLE_ID_KEY, this._statsigMetadata.stableID);
        }
    };
    Identity.prototype.getUserCacheKey = function () {
        return (0, Hashing_1.getUserCacheKey)(this._user);
    };
    Identity.prototype._getUUID = function () {
        var uuid = '';
        for (var i = 0; i < 32; i++) {
            if (i === 8 || i === 12 || i === 16 || i === 20) {
                uuid += '-';
            }
            var randomDigit = (Math.random() * 16) | 0;
            if (i === 12) {
                uuid += '4';
            }
            else if (i === 16) {
                uuid += ((randomDigit & 3) | 8).toString(16);
            }
            else {
                uuid += randomDigit.toString(16);
            }
        }
        return uuid;
    };
    return Identity;
}());
exports.default = Identity;
